// extracted by mini-css-extract-plugin
export default {"container":"YY-z","list":"ZY-z"};